export default __webpack_public_path__ + "static/media/Particle.b1cfaa5d.png";